var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:_vm.sortableClass,style:(_vm.columnStyles),on:{"click":function () {
      _vm.$emit('click')
      _vm.sort()
    }}},[_vm._t("default",[_c('span',{class:_vm.labelClass,on:{"click":function($event){_vm.$emit('clicked')}}},[_vm._v(_vm._s(_vm.label || _vm.id))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.sorting),expression:"sorting"}],staticClass:"datatable-sort-arrow",class:_vm.sortArrowClass})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03f90b35","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datatables/AppDatatableColumn.vue
// module id = null
// module chunks = 